namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmSpisovyUzel extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmSpisovyUzelReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmSpisovyUzelObj & GContent;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;
        private adxCheckIcoNad: number;    // P��znak zda kontrolovat I�O nad��zen�ho objektu

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmSpisovyUzelObj());
            this.detailObj.createBase({
                contentName: "detailAdmSpisovyUzel",
                contentCaption: "jres:29930955",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            this.detailObj.adxCheckIcoNad = this.adxCheckIcoNad;
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.createAdmDenikSslSpisovyUzelTab());
                tabs.push(this.detailObj.createAdmSpisovyUzelProPredavaniTab());
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.createAdmDenikSslSpisovyUzelGroup());
                groups.push(this.detailObj.createAdmSpisovyUzelProPredavaniGroup());
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailAdmSpisovyUzel", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmSpisovyUzelObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmSpisovyUzelReadDto> {
        adxCheckIcoNad: number;

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return (this.data.ixs_su) ? this.data.ixs_su : "";
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmSpisovyUzelSaveDto, close: boolean) {
            if (data.priz_vyp == 0)
                data.mailbox = "";
            (this.cnt.isl.AdmSpisovyUzel.upsert({ data: data }).get() as any).done((output) => {
                Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderGinspod");
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                if (err.responseJSON.exception.containsNonFatal != true)
                    this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmSpisovyUzel", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmSpisovyUzel.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                {
                    favorite: true,
                    type: "static",
                    visible: this.options.newRecord == false,
                    caption: "jres:33000138",
                    icon: "fa-link",
                    children: [
                        { action: this.cnt.actions.actOpenDenikSslSpisovyUzel },
                        { action: this.cnt.actions.actOpenSeznamAdmSpisovyUzelProPredavani }
                    ]
                },
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenDenikSslSpisovyUzel: {
                    caption: "jres:33000910",
                    icon: "fa-link",
                    run: () => {
                        this.openSeznamAdmDenikSslSpisovyUzel();
                    }
                },
                actOpenSeznamAdmSpisovyUzelProPredavani: {
                    icon: "fa-link",
                    caption: "jres:33000914", //RC 33000914 : Spisov� uzly pro p�ed�v�n�
                    run: (ev, ctx) => {
                        this.openSeznamAdmSpisovyUzelProPredavani();
                    }
                },
                actOpenNadrizenySpisUzel: {
                    icon: "gi-detail",
                    caption: "jres:33000921", //RC 33000921 : Nad��zen� spisov� uzel
                    enabled: false,
                    captionVisible: "never",
                    run: () => {
                        this.openNadrizenySpisUzel()
                    }
                },
                actOpenZodpovednaFunkce: {
                    icon: "gi-detail",
                    caption: "jres:33000922", //RC 33000922 : Zodpov�dn� funkce
                    enabled: false,
                    captionVisible: "never",
                    run: () => {
                        this.openZodpovednaFunkce()
                    }
                },
                actOpenAdmMailSchranka: {
                    icon: "gi-detail",
                    caption: "jres:33000405", //RC 33000922 : Zodpov�dn� funkce
                    enabled: false,
                    captionVisible: "never",
                    run: () => {
                        this.openMailSchranka()
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.form.form.layoutDescriptor = "L2M2S1"
            this.MakeSection("");
            this.MakeSelectField("ico", Gordic.Prefabs.Select.ginsico(), {
                model: "model.ico=value.ico",
                flag: this.createFlagNemenne()
            });
            this.MakeField("ixs_su", { flag: this.createFlagNemenne() });
            this.MakeField("zkratka");
            this.MakeField("nazev");
            this.MakeField("ofic_nazev");
            this.MakeField("poznamka");
            // GetDatabaseParameter("adx_checkiconad", 0) == 1
            if (this.adxCheckIcoNad === 1) {
                this.MakeSelectField("ixs_nad", Gordic.Prefabs.Select.ginspod(), {
                    change: (ev, ctx) => {
                        this.cnt.actions.actOpenNadrizenySpisUzel?.update({ enabled: ctx.value != null })
                    },
                    model: "model.ico=>value.ico,model.ixs_nad=value.ixs_su",
                    serverFilters: {
                        IcoOrSharedIco: new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element),
                        aktivita: null
                    },
                    dropdown: false,
                    verticalButtons: false,
                    buttons: [
                        { action: this.cnt.actions.actOpenNadrizenySpisUzel }
                    ]
                })
            } else {
                this.MakeSelectField("ixs_nad", Gordic.Prefabs.Select.ginspod(), {
                    change: (ev, ctx) => {
                        this.cnt.actions.actOpenNadrizenySpisUzel?.update({ enabled: ctx.value != null })
                    },
                    model: "model.ixs_nad=value.ixs_su",
                    serverFilters: {
                        aktivita: null
                    },
                    dropdown: false,
                    verticalButtons: false,
                    buttons: [
                        { action: this.cnt.actions.actOpenNadrizenySpisUzel }
                    ]
                })
            }
            this.MakeField("mail");
            this.MakeField("telefon");
            this.MakeField("fax");
            this.MakeField("url");
            this.MakeSelectField("ixs_fun", Gordic.Prefabs.Select.ginsfun(),
                {
                    change: (ev, ctx) => {
                        this.cnt.actions.actOpenZodpovednaFunkce?.update({ enabled: ctx.value != null })
                    },
                    model: "model.ico=>value.ico,model.ixs_fun=value.ixs_fun",
                    serverFilters: {
                        aktivita: null,
                        ico: new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element)
                    },
                    dropdown: false,
                    verticalButtons: false,
                    buttons: [
                        { action: this.cnt.actions.actOpenZodpovednaFunkce }
                    ]
                });
            this.MakeSelectField("ixs_tre", Gordic.Prefabs.Select.ginstre(), {
                model: "model.ico=>value.ico,model.ixs_tre=value.ixs_tre",
                serverFilters: {
                    aktivita: null,
                    IcoOrSharedIco: new Gordic.Forms.Dependency("ico", "ico", true, false, this.cnt.element)
                },
                dropdown: false
            });
            this.MakeSection("")
            this.MakeBool10Field("priz_pod");
            this.MakeBool10Field("priz_vyp", {
                change: (ev, ctx) => {
                    if (ctx.value == true)
                        this.ShowField("mailbox")
                    else
                        this.HideField("mailbox")
                }
            });
            this.MakeSelectField("mailbox", Gordic.Prefabs.Select.admGinsmbx(), {
                model: "model.mailbox=value.mailbox",
                dropdown: false,
                serverFilters: {
                    typ_mbx: 30,
                },
                change: (ev, ctx) => {
                    this.cnt.actions.actOpenAdmMailSchranka?.update({ enabled: ctx.value != null })
                },
                verticalButtons: false,
                buttons: [
                    { action: this.cnt.actions.actOpenAdmMailSchranka }
                ]
            });
            this.MakeBoolField("priz_kur");
            this.MakeBoolField("priz_evy");
            this.MakeBoolField("priz_prut");
            this.MakeBoolField("priz_servis");
            //this.MakeBoolField("priz_spisovna");
            this.MakeField("dat_od");
            this.MakeField("dat_do");
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt(), { model: "model.aktivita=value.aktivita" });
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
            this.MakeField("dat_zmena");
        }

        private openSeznamAdmDenikSslSpisovyUzel() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmDenikSslSpisovyUzel", { ixs_su: this.data.ixs_su })
        }

        private openSeznamAdmSpisovyUzelProPredavani() {
            this.cnt.navigate("Gordic.Adm.WebControls.SeznamAdmSpisovyUzelProPredavani", { ixs_su: this.data.ixs_su })
        }

        private openNadrizenySpisUzel() {
            const nadrizenySpisUzel = this.cnt.findFields("ixs_nad").gfield("getValue");
            if (nadrizenySpisUzel)
                this.cnt.navigate(["Gordic.Adm.WebControls.DetailAdmSpisovyUzel"], { ID: "DetailAdmSpisovyUzel", newRecord: false, ixs_su: nadrizenySpisUzel.ixs_su })
        }

        private openZodpovednaFunkce() {
            const zodpovednaFunkce = this.cnt.findFields("ixs_fun").gfield("getValue");
            if (zodpovednaFunkce != null)
                this.cnt.navigate(["Gordic.Adm.WebControls.DetailAdmFunkcniMisto"], { ID: "DetailAdmFunkcniMisto", newRecord: false, ixs_fun: zodpovednaFunkce.ixs_fun })
        }

        private openMailSchranka() {
            const mailSchranka = this.cnt.findFields("mailbox").gfield("getValue");
            if (mailSchranka)
                this.cnt.navigate(["Gordic.Adm.WebControls.DetailAdmMailSchranka"], { ID: "DetailAdmMailSchranka", newRecord: false, mailbox: mailSchranka.mailbox })
        }

        createAdmDenikSslSpisovyUzelTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-denik-ssl-spisovy-uzel",
                    title: "jres:33000910", //RC 33000863 : ��t�rny fun. m�sta
                    opened: true,
                    locked: true,
                    group: { id: "_tab-denik-ssl-spisovy-uzel" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmDenikSslSpisovyUzel",
                    serverParams: {
                        ID: "SeznamAdmDenikSslSpisovyUzel",
                        ixs_su: this.data.ixs_su,
                        tabOpen: true
                    }
                }
            }
        }

        createAdmSpisovyUzelProPredavaniTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-spisovy-uzel-pro-predani",
                    title: "jres:33000914", //RC 33000863 : ��t�rny fun. m�sta
                    opened: true,
                    locked: true,
                    group: { id: "_tab-spisovy-uzel-pro-predani" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmSpisovyUzelProPredavani",
                    serverParams: {
                        ID: "SeznamAdmSpisovyUzelProPredavani",
                        ixs_su: this.data.ixs_su,
                        tabOpen: true
                    }
                }
            }
        }

        createAdmDenikSslSpisovyUzelGroup(): IGTabGroupOptions {
            return { id: "_tab-denik-ssl-spisovy-uzel", caption: "jres:33000910" }
        }

        createAdmSpisovyUzelProPredavaniGroup(): IGTabGroupOptions {
            return { id: "_tab-spisovy-uzel-pro-predani", caption: "jres:33000914" }
        }
    }
}